<div class="form-group">
  <label for="prod-m">{{ 'attributeManagement.label.key'| translate }}</label>
  <angular2-multiselect [data]="keysList"
      [(ngModel)]="keySelected"
      [settings]="computedSettings"
      (onSelect)="onKeyChange()"
      (onDeSelect)="onKeyChange()"
      (onDeSelectAll)="onKeyChange()">
  </angular2-multiselect>
</div>